// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608250634/js/" + chunkId + "." + {"44":"7be67255","225":"8cdbf600","481":"7e351b7f","486":"66855dab","770":"eba67cdf"}[chunkId] + ".0.05935447043492592.chunk.js";
};